// Shared redux home for the backend-owned party compliance status lists
// (supplier_statuses / client_statuses). These drive the Overview party badges
// and the "can/cannot send/receive work orders" line.
//
// They live in redux (rather than component local state) so that the mutations
// that re-derive them — a settings save or a request publish — can proactively
// refetch them from their own thunks and have every consumer re-render through
// normal redux flow. This replaces the old compliance_refresh token that
// components had to observe.

export const SET_COMPLIANCE_SUPPLIER_STATUSES = 'SET_COMPLIANCE_SUPPLIER_STATUSES';
export const SET_COMPLIANCE_CLIENT_STATUSES = 'SET_COMPLIANCE_CLIENT_STATUSES';

export const setComplianceSupplierStatuses = (supplierStatuses: any[]) => ({
	type: SET_COMPLIANCE_SUPPLIER_STATUSES,
	supplierStatuses,
});

export const setComplianceClientStatuses = (clientStatuses: any[]) => ({
	type: SET_COMPLIANCE_CLIENT_STATUSES,
	clientStatuses,
});

interface CompliancePartyStatusesState {
	supplierStatuses: any[];
	clientStatuses: any[];
}

const initialState: CompliancePartyStatusesState = {
	supplierStatuses: [],
	clientStatuses: [],
};

export default (
	state: CompliancePartyStatusesState = initialState,
	action
): CompliancePartyStatusesState => {
	switch (action.type) {
		case SET_COMPLIANCE_SUPPLIER_STATUSES:
			return { ...state, supplierStatuses: action.supplierStatuses || [] };
		case SET_COMPLIANCE_CLIENT_STATUSES:
			return { ...state, clientStatuses: action.clientStatuses || [] };
		default:
			return state;
	}
};
